import { useEffect, useState } from "react";
import useApi from "./useApi";

interface NetSuiteConfig {
  id: number;
  displayName: string;
  company: string;
  teamId: number;
}

export default function useNetSuiteConfigs(teamId: number) {
  const [items, setItems] = useState<NetSuiteConfig[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const api = useApi();

  useEffect(() => {
    async function fetchConfigs() {
      setLoading(true);
      setError(null);
      try {
        const resp = await api.messaging.get(`NetSuite/Integrations/`);
        if (!resp.ok) {
          throw new Error(
            `Failed to load NetSuite configs: HTTP ${resp.status}`
          );
        }
        const data = await resp.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err instanceof Error ? err.message : String(err));
        setItems([]);
      } finally {
        setLoading(false);
      }
    }

    fetchConfigs();
  }, [api.messaging]);

  return { items, loading, error };
}
